import {UserEventsMap} from '../UserEventsMap'

let startTime = null
let endTime = 0
let sentOnce = false

export default function handlePopupVideo(event, params) {
    const isVideoWatchedEvent = event === UserEventsMap.PAGE_HIDDEN || event === UserEventsMap.POPUP_CLOSED
    const shouldSend = isVideoWatchedEvent && !sentOnce && startTime !== null

    if (event === UserEventsMap.PLAY_VIDEO && startTime === null) {
        startTime = params.startTime
    } else if (event === UserEventsMap.VIDEO_TIMELINE_UPDATED) {
        endTime = params.time
    } else if (shouldSend) {
        sentOnce = true
        const duration = endTime - startTime
        return { event: UserEventsMap.VIDEO_WATCHED, params: { 'Play Duration': duration } }
    }

    return { event, params }
}



// WEBPACK FOOTER //
// ./web/js/userEvents/handlers/handlePopupVideo.js